import { Component, Input } from '@angular/core';

@Component({
  selector: 'allas-download-app-buttons',
  imports: [],
  template: `
    <span
      class="flex {{ flexTypeClass }} gap-2 xl:gap-8 {{ spanMarginStyleClass }}"
    >
      <a
        href="https://apps.apple.com/hn/app/allas-repuestos-bater%C3%ADas/id6752626505?l=en-GB"
        aria-label="Descargar aplicación desde Apple Store"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/allas-icons/app_store.svg"
          alt="Apple Store"
          class="{{ imgHeightStyleClass }} w-auto aspect-[27/8]"
        />
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.allasrepuestos.membresia_lealtad&pcampaignid=web_share"
        aria-label="Descargar aplicación desde Google Play"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/allas-icons/google-play.svg"
          alt="Google Play"
          class="{{ imgHeightStyleClass }} w-auto aspect-[27/8]"
        />
      </a>
      <a
        href="https://appgallery.huawei.com/#/app/C115506247"
        aria-label="Descargar aplicación desde Huawei AppGallery"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="/allas-icons/huawei-appgallery.svg"
          alt="Icono de Huawei AppGallery"
          class="{{ imgHeightStyleClass }} w-auto aspect-[27/8]"
        />
      </a>
    </span>
  `,
})
export class DownloadAppButtons {
  @Input() spanGapStyleClass: string = 'gap-8';
  @Input() spanMarginStyleClass: string = 'mt-8 mb-12';
  @Input() imgHeightStyleClass: string = 'h-11';
  @Input() flexTypeClass: string = 'flex-row';
}
